import { RedirectToPhp } from '@freelancer/redirect-to-php';
import * as Rx from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../redirect-to-php/redirect-to-php.service";
/**
 * This service can be injected as a login service.
 * It redirects to the gaf/login.php page unless `w=t` is set.
 * In future this may just become a `NoRedirectLogin` service.
 */
var Login = /** @class */ (function () {
    function Login(redirectToPhp) {
        this.redirectToPhp = redirectToPhp;
    }
    Login.prototype.redirect = function (next, routeSnapshot) {
        if (routeSnapshot && routeSnapshot.queryParams.w === 't') {
            return Rx.of(true);
        }
        return this.redirectToPhp.doRedirect("/login?next=" + next);
    };
    Login.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Login_Factory() { return new Login(i0.ɵɵinject(i1.RedirectToPhp)); }, token: Login, providedIn: "root" });
    return Login;
}());
export { Login };
